<template>
  <el-container>
    <el-main>
      <el-table :data="tableData" border style="width: 100%;" @row-dblclick="rowdbclk">
        <el-table-column prop="sid" label="序号" width="60" v-if="false"></el-table-column>
        <el-table-column prop="scompany" label="公司名称" width="100"></el-table-column>
        <el-table-column prop="scontacts" label="联系人" width="100"></el-table-column>
        <el-table-column prop="sop" label="操作人" width="100"></el-table-column>
        <el-table-column label="登录/退出" width="100">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.blogin"></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="下单" width="100">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.bxd"></el-checkbox>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="restpassword(scope.row)" type="text" size="small">重置密码</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer>
      <el-button>提交</el-button>
      <el-button>重置</el-button>
    </el-footer>
  </el-container>
</template>

<script>
import axios from "axios";
import Qs from "qs";
import global from "../global.vue";
const smodel = "9jzsftbxx";

export default {
  created() {
    this.getdata();
  },
  mounted() {
    
  },
  methods: {
    getdata() {
      this.slogid = window.localStorage.getItem("sloginid");
      //stoken = AES.decrypt(stoken,global.AEScode);
      let that = this;
      var stoken = window.localStorage.getItem("stoken");
      // axios.defaults.headers.common["token"] = stoken;
      axios({
        method: "get",
        url: global.sserverip + "get" + smodel,
        //url: "http://172.18.0.141:8081/get7jnzdr",
        params: { sid: that.sfilter }
      })
        .then(function(res) {
          //TO-DO 先判断下数据是否正确 status
          that.tableData = res.data;
        })
        .catch(function(err) {
          console.log(err);
        });
    }
  },
  data() {
    return {
      slogid: "",
      sfilter: "",
      bedit: true,
      bbrow: false,
      tableData: [
        {
          sid: "1",
          scompany: "图书馆甲",
          scontacts: "张三",
          sop: "Tom",
          blogin: true,
          bxd: false
        },
        {
          sid: "2",
          scompany: "台北书局",
          scontacts: "王二",
          sop: "李四",
          blogin: true,
          bxd: true
        }
      ]
    };
  }
};
</script>


